<template>
  <div id="Sample-results-grid-view">
    <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        :context="context"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="sampleList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true" 
        :pagination="false"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
    </ag-grid-vue>
  </div>
</template>
<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import CellGradeResults from './CellGradeResults.vue'
import ElementEnum from '@/app/shared/ElementEnum';

export default {
  name:"SampleListGrid",  
  /* eslint-disable vue/no-unused-components */
  components: {
    AgGridVue,
    CellGradeResults
  },
  props: {
    selectedMuck: {
      type: Object
    }
  },
  data() {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.sampleId;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'sample',
          width: 125,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('GradeControl.Sample.Title'),
          field: "code",
          width: 165
        },
        {
          headerName: this.$systemUnits.getGradeLabel('Gold'),
          field: "goldGrade",
          width: 125,
          cellRendererFramework: Vue.extend(CellGradeResults),
          valueGetter: (params) => {
            return {
              sampleId: params.data.sampleId,
              grade: this.$systemUnits.convertGradeRounded(params.data.goldGrade, ElementEnum.Gold),
              isExcluded : params.data.isGoldExcluded,
              element : ElementEnum.Gold
            };
          }
        },
        {
          headerName: this.$systemUnits.getGradeLabel('Silver'),
          field: "silverGrade",
          width: 125,
          cellRendererFramework: Vue.extend(CellGradeResults),
          valueGetter: (params) => {
            return {
              sampleId: params.data.sampleId,
              grade: this.$systemUnits.convertGradeRounded(params.data.silverGrade, ElementEnum.Silver),
              isExcluded : params.data.isSilverExcluded,
              element : ElementEnum.Silver
            };
          }
        },
        {
          headerName: this.$t('Copper') + ' (%)',
          field: "copperGrade",
          width: 125,
          cellRendererFramework: Vue.extend(CellGradeResults),
          valueGetter: (params) => {
            return {
              sampleId: params.data.sampleId,
              grade: params.data.copperGrade,
              isExcluded : params.data.isCopperExcluded,
              element : ElementEnum.Copper
            };
          }
        },
        {
          headerName: this.$t('Zinc') + ' (%)',
          field: "zincGrade",
          width: 125,
          cellRendererFramework: Vue.extend(CellGradeResults),
          valueGetter: (params) => {
            return {
              sampleId: params.data.sampleId,
              grade: params.data.zincGrade,
              isExcluded : params.data.isZincExcluded,
              element : ElementEnum.Zinc
            };
          }
        },
        {
          headerName: this.$t('Lead') + ' (%)',
          field: "leadGrade",
          width: 125,
          cellRendererFramework: Vue.extend(CellGradeResults),
          valueGetter: (params) => {
            return {
              sampleId: params.data.sampleId,
              grade: params.data.leadGrade,
              isExcluded : params.data.isLeadExcluded,
              element : ElementEnum.Lead
            };
          }
        }  
      ],
      components: {
        CellGradeResults
      }
    }
  },
  computed: {
    sampleList() {
      if (this.selectedMuck === null)
        return null;

      return this.selectedMuck.samples;
    }
  },
  methods: {
    getMuckTypeCellEditor() {
      return {
        values : this.muckTypeNames
      }
    },
    formatDateTime(params) {
      return this.$options.filters.toDate(params.value);
    },
    getMuckEntries(locationForecastId) {
      if (locationForecastId) {
        return this.$store.dispatch("gradeControl/fetchForecastMucks", locationForecastId);
      }
    },
    updateSample(sample) {
      if (sample) {
        this.$emit("onUpdateSample", sample);
      }
    },
    updateSampleResult(values) {
      const sample = this.selectedMuck.samples.find(s => s.sampleId === values.sampleId);

      if (sample) {
        switch (values.element) {
        case ElementEnum.Gold:
          sample.isGoldExcluded = values.isExcluded;
          break;
        case ElementEnum.Silver:
          sample.isSilverExcluded = values.isExcluded;
          break;
        case ElementEnum.Copper:
          sample.isCopperExcluded = values.isExcluded;
          break;
        case ElementEnum.Zinc:
          sample.isZincExcluded = values.isExcluded;
          break;
        case ElementEnum.Lead:
          sample.isLeadExcluded = values.isExcluded;
          break;
        }
        
        this.$emit("onUpdateSample", sample);
      }
    }

  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>
<style lang="scss">
#Sample-results-grid-view {
   .ag-header-group-text {
     text-align: center;
     border: 1px;
   }
   .ag-header-group-cell-label {
     align-content: center;
   }
}
  </style>
